export default __webpack_public_path__ + "static/media/naj.af779996.png";